module.exports = __webpack_public_path__ + "static/media/shipSmall2.3f0c1d55.png";